<template>
    <div class="cep-modal">
        <h2>{{ getString('informe_cep') }}</h2>
        <div class="input-container">
            <label for="cep">{{ getString('cep') }}</label>
            <div
                id="cep"
                ref="cepDiv"
                class="div-input-android"
                :class="{'active-input': isTheActiveInput('cepDiv'), 'error-input': cepError}"
                @click="switchActiveInput('cepDiv')">
            </div>
            <span v-if="cepError" class="error-message">{{ getString('cep_invalido') }}</span>
            <div v-if="checkcpf">
                <div class="field-wrapper">
                    <div class="field-wrapper">
                        <label for="name">{{ getString('nome_fantasia') }}</label>
                        <div
                            id="fantasia"
                            ref="fantasiaDiv"
                            class="div-input-android"
                            :class="{'active-input': isTheActiveInput('fantasiaDiv'), 'error-input': fantasiaError}"
                            @click="switchActiveInput('fantasiaDiv')">
                        </div>
                        <span v-if="fantasiaError" class="error-message">{{ getString('nome_fantasia_obrigatorio') }}</span>
                    </div>
                    <div class="field-wrapper">
                        <label for="registro_estado">{{ getString('registro_estado') }}</label>
                        <div
                            id="registro_estado"
                            ref="registroEstadoDiv"
                            class="div-input-android select-field"
                            :class="{'active-input': isTheActiveInput('registroEstadoDiv'), 'error-input': registroEstadoError}"
                            @click="toggleRegistroEstadoOptions">
                            {{ selectedRegistroEstado || 'Selecione uma opção' }}
                        </div>
                        <span v-if="registroEstadoError" class="error-message">{{ getString('registro_estado_obrigatorio') }}</span>
                        <div v-if="showRegistroEstadoOptions" class="options-dropdown">
                            <div
                                class="option-item"
                                v-for="option in registroEstadoOptions"
                                :key="option"
                                @click="selectRegistroEstado(option)">
                                {{ option }}
                            </div>
                        </div>
                    </div>
                    <div class="field-wrapper">
                        <label for="estado">{{ getString('UF') }}</label>
                        <div
                            id="estado"
                            ref="estadoDiv"
                            class="div-input-android"
                            :class="{'active-input': isTheActiveInput('estadoDiv'), 'error-input': estadoError}"
                            @click="switchActiveInput('estadoDiv')">
                        </div>
                        <span v-if="estadoError" class="error-message">{{ getString('estado_obrigatorio') }}</span>
                    </div>
                    <div class="field-wrapper">
                        <label for="cidade">{{ getString('cidade') }}</label>
                        <div
                            id="cidade"
                            ref="cidadeDiv"
                            class="div-input-android"
                            :class="{'active-input': isTheActiveInput('cidadeDiv'), 'error-input': cidadeError}"
                            @click="switchActiveInput('cidadeDiv')">
                        </div>
                        <span v-if="cidadeError" class="error-message">{{ getString('cidade_obrigatorio') }}</span>
                    </div>
                </div>
                <label for="bairro">{{ getString('bairro') }}</label>
                <div
                    id="bairro"
                    ref="bairroDiv"
                    class="div-input-android"
                    :class="{'active-input': isTheActiveInput('bairroDiv')}"
                    @click="switchActiveInput('bairroDiv')">
                </div>
                <label for="rua">{{ getString('rua') }}</label>
                <div
                    id="rua"
                    ref="ruaDiv"
                    class="div-input-android"
                    :class="{'active-input': isTheActiveInput('ruaDiv'), 'error-input': ruaError}"
                    @click="switchActiveInput('ruaDiv')">
                </div>
                <span v-if="ruaError" class="error-message">{{ getString('rua_obrigatorio') }}</span>
                <div class="address-fields">
                    <div class="field-wrapper">
                        <label for="numero">{{ getString('numero') }}</label>
                        <div
                            id="numero"
                            ref="numeroDiv"
                            class="div-input-android"
                            :class="{'active-input': isTheActiveInput('numeroDiv'), 'error-input': numeroError}"
                            @click="switchActiveInput('numeroDiv')">
                        </div>
                        <span v-if="numeroError" class="error-message">{{ getString('numero_obrigatorio') }}</span>
                    </div>
                    <div class="field-wrapper">
                        <label for="complemento">{{ getString('complemento') }}</label>
                        <div
                            id="complemento"
                            ref="complementoDiv"
                            class="div-input-android"
                            :class="{'active-input': isTheActiveInput('complementoDiv')}"
                            @click="switchActiveInput('complementoDiv')">
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <AndroidKeyboard
            id="android-keyboard"
            :inputElement="inputElement"
            :layout="layout"
            :isPasswordField="false"
            :onInput="handleInput"
            :maxCaracteres="getMaxCaracteres()">
        </AndroidKeyboard>

        <div class="buttons-container">
            <DefaultButton
                :text="getString('cancelar')"
                @defaultBtnClick="cancel()"
                class="buttons">
            </DefaultButton>
            <DefaultButton
                :text="getString('confirmar')"
                @defaultBtnClick="confirm()"
                class="buttons"
                :disabled="!confirmed">
            </DefaultButton>
        </div>
    </div>
</template>

<script>
import DefaultButton from '@/components/DefaultButton.vue'
import AndroidKeyboard from '@/components/AndroidKeyboard/AndroidKeyboard'
import keyboardLayout from '@/assets/libs/keyboardLayout'
import LocaleController from '@/assets/controllers/LocaleController'
import axios from 'axios'

export default {
    components: {
        DefaultButton,
        AndroidKeyboard
    },
    data () {
        return {
            inputElement: null,
            layout: keyboardLayout.TEXT,
            checkcpf: true,
            rawCepValue: '',
            numeroError: false,
            cepError: false,
            ruaError: false,
            fantasiaError: false,
            registroEstadoError: false,
            estadoError: false,
            cidadeError: false,
            confirmed: false,
            selectedRegistroEstado: '',
            showRegistroEstadoOptions: false,
            registroEstadoOptions: [
                'ISENTO',
                'INSCRIÇÃO NUMÉRICA',
                'NULO OU NÃO CONTRIBUINTE'
            ],
            buttons: [
                {
                    text: this.getString('cancelar'),
                    action: this.cancel
                },
                {
                    text: this.getString('confirmar'),
                    action: this.confirm
                }
            ]
        }
    },
    mounted () {
        this.inputElement = this.$refs.cepDiv
        this.switchActiveInput('cepDiv')
    },
    methods: {
        getString (key) {
            return LocaleController.getString(key)
        },
        isTheActiveInput: function (divReference) {
            return this.inputElement === this.$refs[divReference]
        },
        switchActiveInput: function (divReference) {
            const newInput = this.$refs[divReference]

            if (newInput && this.inputElement !== newInput) {
                const currentContent = newInput.textContent
                this.inputElement = newInput

                this.$nextTick(() => {
                    if (newInput.textContent === '' && currentContent !== '') {
                        newInput.textContent = currentContent
                    }
                })
            }
        },
        getMaxCaracteres: function () {
            if (this.inputElement === this.$refs.cepDiv) {
                return 9
            }
            return null
        },
        handleInput: function (value) {
            const errorMap = {
                numeroDiv: 'numeroError',
                ruaDiv: 'ruaError',
                fantasiaDiv: 'fantasiaError',
                estadoDiv: 'estadoError',
                cidadeDiv: 'cidadeError',
                cepDiv: 'cepError'
            }

            for (const [ref, errorProp] of Object.entries(errorMap)) {
                if (this.inputElement === this.$refs[ref]) {
                    this[errorProp] = false
                    break
                }
            }

            if (this.inputElement === this.$refs.cepDiv) {
                this.cepError = false
                const onlyNumbers = value.replace(/\D/g, '')
                this.rawCepValue = onlyNumbers.slice(0, 8)

                if (this.$refs.cepDiv.textContent.length === 9) {
                    this.findCep(this.rawCepValue)
                } else {
                    this.confirmed = false
                }

                if (this.rawCepValue.length > 5) {
                    return this.rawCepValue.slice(0, 5) + '-' + this.rawCepValue.slice(5)
                }
                return this.rawCepValue
            }
            return value
        },
        formatCep: function (value) {
            // Formata CEP: 00000-000
            const onlyNumbers = value.replace(/\D/g, '').slice(0, 8)

            if (onlyNumbers.length > 5) {
                this.findCep(onlyNumbers)
                return onlyNumbers.slice(0, 5) + '-' + onlyNumbers.slice(5)
            }
            return onlyNumbers
        },
        cancel: function () {
            this.$emit('closeCepModal')
        },
        toggleRegistroEstadoOptions: function () {
            this.showRegistroEstadoOptions = !this.showRegistroEstadoOptions
        },
        selectRegistroEstado: function (option) {
            this.selectedRegistroEstado = option
            this.$refs.registroEstadoDiv.textContent = option
            this.showRegistroEstadoOptions = false
            this.registroEstadoError = false
        },
        getRefValue: function (refName) {
            return this.$refs[refName] && this.$refs[refName].textContent ? this.$refs[refName].textContent.trim() : ''
        },
        confirm: function () {
            if (this.hasError()) {
                return
            }

            const addressData = {
                fantasia: this.getRefValue('fantasiaDiv'),
                registroEstado: this.selectedRegistroEstado,
                cep: this.rawCepValue,
                estado: this.getRefValue('estadoDiv'),
                cidade: this.getRefValue('cidadeDiv'),
                bairro: this.getRefValue('bairroDiv'),
                rua: this.getRefValue('ruaDiv'),
                numero: this.getRefValue('numeroDiv'),
                complemento: this.getRefValue('complementoDiv')
            }

            this.$emit('address', addressData)
        },
        hasError: function () {
            this.cepError = false
            this.fantasiaError = false
            this.registroEstadoError = false
            this.estadoError = false
            this.cidadeError = false
            this.ruaError = false
            this.numeroError = false

            let hasError = false

            if (this.rawCepValue.length < 8 || this.$refs.cepDiv.textContent.length !== 9 || !this.confirmed) {
                this.cepError = true
                hasError = true
            }

            const requiredFields = [
                { ref: 'fantasiaDiv', error: 'fantasiaError' },
                { ref: 'estadoDiv', error: 'estadoError' },
                { ref: 'cidadeDiv', error: 'cidadeError' },
                { ref: 'ruaDiv', error: 'ruaError' },
                { ref: 'numeroDiv', error: 'numeroError' }
            ]

            for (const field of requiredFields) {
                if (this.getRefValue(field.ref) === '') {
                    this[field.error] = true
                    hasError = true
                }
            }

            if (this.selectedRegistroEstado === '') {
                this.registroEstadoError = true
                hasError = true
            }

            return hasError
        },
        async findCep (cep) {
            const sanitizedCep = cep.replace(/\D/g, '')

            if (sanitizedCep.length === 8) {
                try {
                    const response = await axios.get(`https://viacep.com.br/ws/${sanitizedCep}/json/`)
                    const data = response.data

                    if (data.erro) {
                        this.confirmed = false
                        this.cepError = true
                        throw new Error('CEP inválido')
                    }

                    if (this.$refs.estadoDiv) {
                        this.$refs.estadoDiv.textContent = data.uf
                    }
                    if (this.$refs.cidadeDiv) {
                        this.$refs.cidadeDiv.textContent = data.localidade
                    }
                    if (this.$refs.bairroDiv) {
                        this.$refs.bairroDiv.textContent = data.bairro
                    }
                    if (this.$refs.ruaDiv) {
                        this.$refs.ruaDiv.textContent = data.logradouro
                    }

                    this.confirmed = true
                    return data
                } catch (error) {
                    this.cepError = true
                    this.confirmed = false
                    console.error('Erro ao buscar CEP:', error)
                    return null
                }
            }
            return null
        }
    }
}
</script>

<style scoped lang="less">
@import (reference) url("../assets/common.less");

.cep-modal {
    z-index: 10;
    width: 100%;
    height: auto;
    max-height: 95vh;
    overflow-y: auto;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 20px;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: column;

    h2 {
        font-size: 40px;
        color: @primary-color;
        margin-bottom: 20px;
        text-align: center;
    }

    .error-input {
        border: 3px solid #ff0000 !important;
    }

    .error-message {
        color: #ff0000;
        font-size: 0.9rem;
        display: block;
        margin-bottom: 10px;
    }

    .input-container {
        margin: 20px 0;
        flex: 0 0 auto;

        .address-fields {
            display: flex;

            > div {
                flex: 1;
                display: flex;
                flex-direction: column;
            }

            label {
                margin-top: 0;
                margin-bottom: 5px;
            }

            .div-input-android {
                width: 80%;
            }
        }

        .div-input-android {
            position: relative;
            display: flex;
            align-items: center;
            font-size: 2rem;
            height: 55px;
            background-color: white;
            color: black;
            border: 2px solid @black;
            padding: 0 20px;
            width: 90%;
            margin-bottom: 10px;
        }

        .active-input {
            border: 3px solid @primary-color;
        }

        label {
            display: block;
            margin-bottom: 5px;
            margin-top: 10px;
            font-weight: bold;
        }

        .field-wrapper {
            position: relative;
        }

        .select-field {
            cursor: pointer;
            user-select: none;
        }

        .options-dropdown {
            position: absolute;
            top: 100%;
            left: 0;
            width: 90%;
            background-color: white;
            border: 2px solid @black;
            border-radius: 4px;
            margin-top: 5px;
            z-index: 1000;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);

            .option-item {
                padding: 15px 20px;
                cursor: pointer;
                font-size: 1.5rem;
                border-bottom: 1px solid #e0e0e0;

                &:last-child {
                    border-bottom: none;
                }

                &:hover {
                    background-color: #f5f5f5;
                }

                &:active {
                    background-color: @primary-color;
                    color: white;
                }
            }
        }
    }

    #android-keyboard {
        margin: 20px 0;
        flex: 0 0 auto;
    }

    .buttons-container {
        display: flex;
        justify-content: space-around;
        margin-top: 20px;
        flex: 0 0 auto;

        .buttons {
            flex: 1;
            min-height: 50px;
        }

        button:first-of-type{
            background: white;
            border: solid 1px black;
            color: black;
        }
    }
}

@media (max-width: 698px) {
    .cep-modal {
        width: 100%;
        padding: 15px;
        height: 125%;
        top: 57%;

        h2 {
            font-size: 24px;
        }

        .input-container {
            margin: 0px 0;
            flex: 0 0 auto;

            .address-fields {
                display: flex;;
                align-items: flex-start;
                margin-bottom: 0px;

                > div {
                    flex: 1;
                    display: flex;
                    flex-direction: column;
                }

                label {
                    width: fit-content;
                    margin-top: 0;
                    margin-bottom: 0px;
                }

                .div-input-android {
                    width: 60%;
                }
            }
            .div-input-android {
                font-size: 1rem;
                height: 24px;
            }
        }

        #android-keyboard {
            width: 100%;
            margin: 0px 0;
        }
    }
}

@media (min-width: 699px) and (max-width: 768px) {
    .cep-modal {
        h2 {
            font-size: 32px;
        }

        .input-container {
            .div-input-android {
                font-size: 1.8rem;
                height: 50px;
            }
        }
    }
}

@media (min-width: 769px) and (max-width: 1025px) {
    .cep-modal {
        width: 90%;
        max-height: 90vh;
        top: 50%;

        h2 {
            font-size: 28px;
            margin-bottom: 15px;
        }

        .input-container {
            margin: 10px 0;

            .div-input-android {
                font-size: 1.4rem;
                height: 40px;
                margin-bottom: 8px;
            }

            label {
                font-size: 0.9rem;
                margin-top: 8px;
                margin-bottom: 3px;
            }

            .address-fields {
                gap: 8px;
                margin-bottom: 8px;

                .div-input-android {
                    width: 85%;
                }
            }
        }

        #android-keyboard {
            margin: 10px 0;
        }

        .buttons-container {
            margin-top: 15px;
            gap: 8px;

            .buttons {
                min-height: 40px;
                font-size: 1rem;
            }
        }
    }
}

@media (min-width: 1024px) and (max-width: 1366px) and (orientation: landscape) {
    .cep-modal {
        width: 80%;
        max-height: 85vh;
        top: 50%;
        padding: 25px;

        h2 {
            font-size: 32px;
            margin-bottom: 20px;
        }

        .input-container {
            margin: 15px 0;

            .div-input-android {
                font-size: 1.5rem;
                height: 45px;
                margin-bottom: 10px;
                width: 85%;
            }

            label {
                font-size: 1rem;
                margin-top: 10px;
                margin-bottom: 5px;
            }

            .address-fields {
                display: flex;
                align-items: flex-start;
                margin-bottom: 10px;

                .div-input-android {
                    width: 80%;
                }
            }
        }

        #android-keyboard {
            margin: 15px 0;
        }

        .buttons-container {
            margin-top: 20px;
            gap: 15px;

            .buttons {
                min-height: 45px;
                font-size: 1.1rem;
            }
        }
    }
}

</style>



// WEBPACK FOOTER //
// src/components/CepModalGom.vue